import { render, staticRenderFns } from "./Scope.vue?vue&type=template&id=2084c6a1&scoped=true"
import script from "./Scope.vue?vue&type=script&lang=js"
export * from "./Scope.vue?vue&type=script&lang=js"
import style0 from "./Scope.vue?vue&type=style&index=0&id=2084c6a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2084c6a1",
  null
  
)

export default component.exports